import { chakraTheme } from "@/theme/chakraTheme"
import { Box, Img, Text } from "@chakra-ui/react"
import React from "react"
import { FALLBACKIMAGES } from "../../common/commonConstants"

interface ProductThumbnailType2Props {
  bg?: string
  prodPhoto: string | null | undefined
  prodCode: string | null | undefined
  onClickCallBack?: (e: React.MouseEvent) => void
}
const fallBackText = "---"
const fallBackImage = FALLBACKIMAGES["150x150"]
export const ProductThumbnailType2 = ({
  bg = chakraTheme.colors.imageFallBackBackground,
  prodPhoto,
  prodCode,
  onClickCallBack
}: ProductThumbnailType2Props): JSX.Element => (
  <Box
    onClick={e => {
      if (onClickCallBack) {
        onClickCallBack(e)
      }
    }}
    p="1"
    display="flex"
    width={"100%"}
    alignItems="center"
    justifyContent="center"
    cursor={"pointer"}
  >
    <Box margin="auto" w="100%" textAlign="left" width={["118px", "196px", "196px", "196px"]} paddingBottom={2}>
      <Box
        height={["118px", "196px", "196px", "196px"]}
        width={["118px", "196px", "196px", "196px"]}
        bg={bg}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius={"4px"}
      >
        {prodPhoto ? (
          <Box
            height="100%"
            width="100%"
            borderRadius={"4px"}
            boxShadow="0 0 18px rgba(0, 0, 0, 0.1)"
            border="1px solid rgba(133, 133, 133, 0.09)"
            background={`url('${prodPhoto}') no-repeat 50% 50%`}
            backgroundSize="contain"
          />
        ) : (
          <Img src={fallBackImage} alt="Product placeholder" height="100%" width="100%" objectFit="contain" />
        )}
      </Box>
      <Text variant="RButton2" color="primary" pt={[0, 0, 0, "6px"]}>
        {prodCode ?? fallBackText}
      </Text>
    </Box>
  </Box>
)
